module.exports = __webpack_public_path__ + "static/media/icon-infinity.c742cbeb.png";